import {
  Box,
  Chip,
  CircularProgress,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { useNetworkObserver } from 'data-layer-cr/dist/network';
import { colors } from 'design-system';
import { getChipPlanByOptionDescription } from 'src/functions/individualOptionHelpers';
import { REQUEST_PRICING } from 'src/store/quotation/requestIdentifiers';
import AmountSection from './AmountSection';
import SelectPlan, { Plan } from './SelectPlan';

const useStyles = makeStyles({
  loading: {
    color: colors.bright_turquoise,
  },
});

type OptionPriceCardProps = {
  anualPrice: number;
  moneyType: string;
  packageOption: number;
  plans: Plan[];
  onChangeEndorsementCustomerProfile: (codeEndorsement: string) => void;
  currentSelectedEndorsement: string;
  loadingPackage?: number;
};

export const OptionPriceCard = ({
  anualPrice,
  moneyType,
  packageOption,
  plans,
  onChangeEndorsementCustomerProfile,
  currentSelectedEndorsement,
  loadingPackage,
}: OptionPriceCardProps): JSX.Element => {
  const requestingQuotationState = useNetworkObserver(REQUEST_PRICING);
  const chipPlan = getChipPlanByOptionDescription(
    currentSelectedEndorsement.split('/')[0],
    moneyType,
  );
  const classes = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      width="100%"
      style={{ gap: '0.5rem' }}
    >
      <Typography
        style={{
          fontSize: '15px',
          fontWeight: 700,
          lineHeight: '100%',
          letterSpacing: '0.2px',
          color: '#7E8084',
          width: '100%',
          marginTop: '10px',
        }}
        align="left"
      >
        Selecciona un plan
      </Typography>
      <SelectPlan
        onChangeEndorsement={onChangeEndorsementCustomerProfile}
        pricingPlans={plans}
        currentSelectedEndorsement={currentSelectedEndorsement}
        packageOption={packageOption}
      />
      <Chip
        label={
          <Typography
            variant="caption"
            style={{ fontSize: 15, color: chipPlan.colorText }}
          >
            {chipPlan.title}
          </Typography>
        }
        style={{
          backgroundColor: chipPlan.colorBackground,
        }}
      />
      {requestingQuotationState === 'requesting' &&
      loadingPackage === packageOption ? (
        <Grid item container justifyContent="center" title="loading">
          <CircularProgress size={40} className={classes.loading} />
        </Grid>
      ) : (
        <AmountSection anualPrice={anualPrice} moneyType={moneyType} />
      )}
    </Box>
  );
};

export default OptionPriceCard;
